/**
 * Alert — 인라인 알림 배너 컴포넌트
 *
 * - info / success / warning / danger 변형
 * - closable prop으로 닫기 버튼 표시
 */

import { ReactNode } from 'react'
import { AlertTriangle, CheckCircle2, Info, XCircle, X } from 'lucide-react'
import { cn } from './cn'
import styles from './Alert.module.css'

interface AlertProps {
  variant: 'info' | 'success' | 'warning' | 'danger'
  title?: string
  children: ReactNode
  closable?: boolean
  onClose?: () => void
  className?: string
}

const variantIcons = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  danger: XCircle,
}

export function Alert({ variant, title, children, closable, onClose, className }: AlertProps) {
  const Icon = variantIcons[variant]

  return (
    <div className={cn(styles.root, styles[variant], className)} role="alert">
      <span className={styles.icon}>
        <Icon width={20} height={20} />
      </span>
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {children}
      </div>
      {closable && (
        <button
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="닫기"
          type="button"
        >
          <X width={16} height={16} />
        </button>
      )}
    </div>
  )
}
